import React, { useMemo, useState } from "react";

const tierKey = (tier) =>
  tier.toLowerCase().replace("é", "e").replace(/\s+/g, "-");

/* "2026-09-06" doit être lu comme une date locale : sans l'heure, JS le parse en UTC
   et l'affichage décale d'un jour dans les fuseaux à l'ouest de Greenwich. */
const parseLocal = (d) => new Date(`${d}T00:00:00`);

const toYMD = (d) => d.replaceAll("-", "");

/* Fin exclusive pour Google Agenda / iCal : arithmétique en UTC pour éviter
   qu'un passage à l'heure d'été absorbe le +1 jour. */
const nextDay = (d) => {
  const x = new Date(`${d}T00:00:00Z`);
  x.setUTCDate(x.getUTCDate() + 1);
  return x.toISOString().slice(0, 10);
};

const byDateAsc = (a, b) => parseLocal(a.date) - parseLocal(b.date);
const byDateDesc = (a, b) => parseLocal(b.date) - parseLocal(a.date);
const endOfDay = (d) => new Date(`${d}T23:59:59`);
const isPastEvent = (ev) => endOfDay(ev.end || ev.date) < new Date();

export default function EventsSection() {
  const [evTab, setEvTab] = useState("upcoming");
  const [evQuery, setEvQuery] = useState("");

  const EVENTS = useMemo(
	() => [
	  { id: "2026-09-06-shiai-septembre", title: "Shiai de Septembre", date: "2026-09-06", place: "Rue des Longues Haies, 7100 Haine-Saint-Paul", level: "U18+", grade: "1e Kyu & 1e Dan", tier: "Régional", signup: "Sur place" },
	  { id: "2026-09-19-brabant-open-u15-u21", title: "Brabant Open", date: "2026-09-19", place: "Lindeboomstraat 30, 3080 Tervuren", level: "U15 / U21+", grade: "3e Kyu et +", tier: "National B" },
	  { id: "2026-09-20-brabant-open-u18", title: "Brabant Open", date: "2026-09-20", place: "Lindeboomstraat 30, 3080 Tervuren", level: "U18", grade: "3e Kyu et +", tier: "National B" },

	  { id: "2026-10-03-hainaut-cup-u18-u15", title: "Hainaut Cup", date: "2026-10-03", place: "Sambrexpo, JF Kennedy 150, 6250 Roselies", level: "U18 / U15", grade: "3e Kyu et +", tier: "National B" },
	  { id: "2026-10-04-hainaut-cup-jeunes", title: "Hainaut Cup", date: "2026-10-04", place: "Sambrexpo, JF Kennedy 150, 6250 Roselies", level: "U13 / U11 / U9", tier: "National" },
	  { id: "2026-10-04-shiai-octobre", title: "Shiai d'Octobre", date: "2026-10-04", place: "Rue des Écoles 6, 4287 Lincent", level: "U18+", grade: "1e Kyu & 1-2-3-4 Dan", tier: "Régional", signup: "Sur place" },
	  { id: "2026-10-18-regional-seniors", title: "Régional Séniors", date: "2026-10-18", place: "Rue Porte-à-Camp 7, 7971 Basècles", level: "U18+", grade: "3e Kyu et +", tier: "National B" },
	  { id: "2026-10-24-open-van-zaventem", title: "Open van Zaventem", date: "2026-10-24", place: "Hoogstraat 3, 1930 Zaventem", level: "U11 / U13", tier: "Régional" },
	  { id: "2026-10-25-zaventem-regenboog", title: "Zaventem Regenboog", date: "2026-10-25", place: "Hoogstraat 3, 1930 Zaventem", level: "U18+", grade: "3e Kyu et +", tier: "Provincial" },
	  { id: "2026-10-31-national-seniors", title: "National Séniors", date: "2026-10-31", level: "U18+", grade: "3e Kyu et +", tier: "National A" },

	  { id: "2026-11-01-shiai-novembre", title: "Shiai de Novembre", date: "2026-11-01", place: "Rue de Beauffaux 2A, 5081 Saint-Denis", level: "U18+", grade: "1e Kyu et 1e Dan", tier: "Régional", signup: "Sur place" },
	  { id: "2026-11-14-interclub-w1", title: "Interclub W1", date: "2026-11-14", level: "U18+", grade: "3e Kyu et +", tier: "Régional" },
	  { id: "2026-11-15-interclub-w1", title: "Interclub W1", date: "2026-11-15", level: "U18+", grade: "3e Kyu et +", tier: "Régional" },
	  { id: "2026-11-28-interclub-w2", title: "Interclub W2", date: "2026-11-28", level: "U18+", grade: "3e Kyu et +", tier: "Régional" },
	  { id: "2026-11-29-interclub-w2", title: "Interclub W2", date: "2026-11-29", level: "U18+", tier: "Régional" },

	  { id: "2026-12-06-shiai-decembre", title: "Shiai de Décembre", date: "2026-12-06", place: "Rue Général de Gaulle 53, 1310 La Hulpe", level: "U18+", grade: "1e Kyu & 1-2 Dan", tier: "Régional", signup: "Sur place" },
	  { id: "2026-12-12-interclub-w3", title: "Interclub W3", date: "2026-12-12", level: "U18+", grade: "3e Kyu et +", tier: "Régional" },
	  { id: "2026-12-13-interclub-w3", title: "Interclub W3", date: "2026-12-13", level: "U18+", grade: "3e Kyu et +", tier: "Régional" },
	  { id: "2026-12-16-national-universitaire", title: "National Universitaire", date: "2026-12-16", level: "U18+", grade: "3e Kyu et +", tier: "National" },
	],
	[]
  );

  const filteredEvents = useMemo(() => {
	const inTab = EVENTS.filter((ev) => (evTab === "upcoming" ? !isPastEvent(ev) : isPastEvent(ev)));

	const haystack = (ev) =>
	  `${ev.title} ${ev.place || ""} ${ev.level || ""} ${ev.grade || ""} ${ev.tier || ""}`.toLowerCase();

	const byQuery = evQuery ? inTab.filter((ev) => haystack(ev).includes(evQuery.toLowerCase())) : inTab;

	return [...byQuery].sort(evTab === "upcoming" ? byDateAsc : byDateDesc);
  }, [EVENTS, evTab, evQuery]);

  const groups = useMemo(() => {
	const fmtKey = (d) => parseLocal(d).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
	return filteredEvents.reduce((acc, ev) => {
	  const k = fmtKey(ev.date);
	  (acc[k] ||= []).push(ev);
	  return acc;
	}, {});
  }, [filteredEvents]);

  const formatDateRange = (ev) => {
	const d1 = parseLocal(ev.date);
	const d = d1.toLocaleDateString("fr-FR", { day: "2-digit" });
	const m = d1.toLocaleDateString("fr-FR", { month: "short" });

	if (!ev.end) return { d, m };

	const d2 = parseLocal(ev.end);
	const dEnd = d2.toLocaleDateString("fr-FR", { day: "2-digit" });
	const mEnd = d2.toLocaleDateString("fr-FR", { month: "short" });

	return {
	  d: `${d}–${dEnd}`,
	  m: d1.getMonth() === d2.getMonth() ? m : `${m}–${mEnd}`,
	};
  };

  const eventDetails = (ev) =>
	[ev.level, ev.grade, ev.tier, ev.signup && `Inscription : ${ev.signup}`]
	  .filter(Boolean)
	  .join(" — ");

  const gcalUrl = (ev) => {
	const start = toYMD(ev.date);
	const endExclusive = toYMD(ev.end ? nextDay(ev.end) : nextDay(ev.date));

	const params = new URLSearchParams({
	  action: "TEMPLATE",
	  text: ev.title,
	  dates: `${start}/${endExclusive}`,
	  location: ev.place || "",
	  details: eventDetails(ev),
	});

	return `https://www.google.com/calendar/render?${params.toString()}`;
  };

  const downloadICS = (ev) => {
	const dtStart = toYMD(ev.date);
	const dtEndExclusive = toYMD(ev.end ? nextDay(ev.end) : nextDay(ev.date));
	const description = eventDetails(ev);

	const ICS = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Wolves Bruxelles//Events//FR
BEGIN:VEVENT
UID:${ev.id}@wolves-bxl
DTSTAMP:${toYMD(new Date().toISOString().slice(0, 10))}T000000Z
DTSTART;VALUE=DATE:${dtStart}
DTEND;VALUE=DATE:${dtEndExclusive}
SUMMARY:${ev.title}
LOCATION:${ev.place || ""}
DESCRIPTION:${description}
END:VEVENT
END:VCALENDAR`;

	const blob = new Blob([ICS], { type: "text/calendar;charset=utf-8" });
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = `${ev.id}.ics`;
	document.body.appendChild(a);
	a.click();
	a.remove();
	URL.revokeObjectURL(url);
  };

  return (
	<section id="evenements" className="section">
	  <div className="container">
		<div className="events-head">
		  <span className="section-label">🏆 Compétitions</span>
		  <h2 className="section-title">Événements</h2>
		  <p className="events-sub">Calendrier des tournois — septembre à décembre 2026.</p>
		</div>

		<div className="ev-controls">
		  <div className="ev-tabs" role="tablist" aria-label="Filtre d'événements">
			<button className={`ev-tab ${evTab === "upcoming" ? "is-active" : ""}`} onClick={() => setEvTab("upcoming")}>
			  À venir
			</button>
			<button className={`ev-tab ${evTab === "past" ? "is-active" : ""}`} onClick={() => setEvTab("past")}>
			  Passés
			</button>
		  </div>

		  <div className="ev-search">
			<input
			  type="search"
			  placeholder="Rechercher un événement…"
			  value={evQuery}
			  onChange={(e) => setEvQuery(e.target.value)}
			  aria-label="Rechercher un événement"
			/>
			<span className="ev-search-ico" aria-hidden>🔎</span>
		  </div>
		</div>

		{Object.keys(groups).length === 0 ? (
		  <div className="events-empty">Aucun événement {evTab === "upcoming" ? "à venir" : "passé"}.</div>
		) : (
		  <div className="events-groups">
			{Object.entries(groups).map(([month, list]) => (
			  <div key={month} className="events-month">
				<h3 className="month-title">{month}</h3>
				<ul className="events-grid">
				  {list.map((ev) => {
					const { d, m } = formatDateRange(ev);
					return (
					  <li key={ev.id} className="event-card">
						<div className="event-date">
						  <span className="d">{d}</span>
						  <span className="m">{m}</span>
						</div>

						<div className="event-body">
						  <div className="event-head">
							<h4 className="event-title">{ev.title}</h4>
							{ev.tier && (
							  <span className={`event-tier tier-${tierKey(ev.tier)}`}>{ev.tier}</span>
							)}
						  </div>

						  {ev.place && (
							<p className="event-meta">
							  <i className="fa-solid fa-location-dot" /> {ev.place}
							</p>
						  )}

						  <p className="event-level">
							<i className="fa-solid fa-users" /> {ev.level}
							{ev.grade && (
							  <>
								{" · "}
								<i className="fa-solid fa-award" /> {ev.grade}
							  </>
							)}
						  </p>

						  {ev.signup && (
							<p className="event-signup">
							  <i className="fa-regular fa-pen-to-square" /> Inscription {ev.signup.toLowerCase()}
							</p>
						  )}

						  <div className="event-actions">
							<a className="btn-mini" href={gcalUrl(ev)} target="_blank" rel="noreferrer">
							  <i className="fa-brands fa-google" /> Google Calendar
							</a>
							<button className="btn-mini ghost" onClick={() => downloadICS(ev)}>
							  <i className="fa-regular fa-calendar-plus" /> Fichier .ics
							</button>
						  </div>
						</div>
					  </li>
					);
				  })}
				</ul>
			  </div>
			))}
		  </div>
		)}
	  </div>
	</section>
  );
}
